<template>
  <div id="likesBCK">
    <v-container>
      <!-- HEADER -->
      <v-layout align-center>
        <!-- BACK ARROW -->
        <v-flex xs1 text-xs-center class="arrowPOS">
          <v-icon @click="$store.dispatch('stopVideo')" class="icon-size-1 icon-transform-1">arrow_back</v-icon>
        </v-flex>
        <v-flex xs11 />
      </v-layout>
      <!-- VOTING -->
      <v-layout
        align-center
        row
        wrap
        text-xs-center
        :style="{'margin-top':'15%'}">
        <!-- QUESTION -->
        <v-flex xs12 class="font-subtitle">{{ $t("likevideo") }}</v-flex>
        <v-layout
          align-center
          row
          wrap
          :style="{'margin-top':'5%'}">
          <v-flex xs2 />
          <!-- LIKE -->
          <v-flex xs3>
            <v-icon 
              :disabled="this.$store.getters.getCurrentVideo.type === 'live'" 
              @click="increaseLikes()" 
              class="thumbSize icon-transform-1 likeColor">
              thumb_up
            </v-icon>
          </v-flex>
          <!-- TIMER -->
          <v-flex xs2 text-xs-center class="font-title ">
            {{ secToMin(counterTimer) }}
          </v-flex>
          <!-- DISLIKE -->
          <v-flex xs3>
            <v-icon 
              :disabled="this.$store.getters.getCurrentVideo.type === 'live'" 
              @click="increaseDislikes()" 
              class="thumbSize icon-transform-1 dislikeColor">
              thumb_down
            </v-icon>
          </v-flex>
          <v-flex xs2 />
          <v-flex xs2 />
          <!-- LIKE NUMBER -->
          <v-flex xs3 class="font-number">{{ likesNUM }}</v-flex>
          <v-flex xs2 />
          <!-- DISLIKE NUMBER -->
          <v-flex xs3 class="font-number">{{ dislikesNUM }}</v-flex>
          <v-flex xs2 />
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      likesNUM: 0,
      dislikesNUM: 0,
      pressFlag: true,
      counterTimer: 60
    };
  },
  methods: {
    increaseLikes() {
      if (this.$store.getters.getCurrentVideo.type === "live") {
        return;
      }
      if (this.pressFlag) {
        this.likesNUM += 1;
        this.pressFlag = false;
        if (this.$store.getters.getCurrentVideo.type === "live") {
          console.log("Update live class likes");
        } else {
          this.$store.dispatch("addLikeToVideo", this.$store.getters.getCurrentVideo.id);
        }
        
        setTimeout(() => {
          this.pressFlag = true;
        }, 1000);
      }
      
    },
    increaseDislikes() {
      if (this.$store.getters.getCurrentVideo.type === "live") {
        return;
      }
      if (this.pressFlag) {
        this.dislikesNUM += 1;
        this.pressFlag = false;
        if (this.$store.getters.getCurrentVideo.type === "live") {
          console.log("Update live class dislikes");
        } else {
          this.$store.dispatch("addDislikeToVideo", this.$store.getters.getCurrentVideo.id);
        }
        setTimeout(() => {
          this.pressFlag = true;
        }, 1000);
      }
    },
    secToMin(sec) {
      const modSec = sec % 60;
      return (sec - (modSec)) / 60 + (modSec > 9 ? ":" : ":0") + parseInt(modSec);
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      if (this.counterTimer === 0) {
        clearInterval(this.interval);
        this.$store.dispatch("stopVideo");
      } else {
        this.counterTimer -= 1;
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<style>
#likesBCK {
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden !important;
}

.arrowPOS {
  position: absolute !important;
  top: 0px;
  left: 0px;
}

.thumbSize {
  font-size: 12em !important;
  -webkit-text-stroke: 8px white;
}

.likeColor {
  color: green !important;
}
.dislikeColor {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Likes.vue